import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from './content/content.component';
import { MarkdownModule } from 'ngx-markdown';
import { SwiperModule } from 'swiper/angular';
import { ComponentsModule } from '../../../components/components.module';
import { LocalizeUrlPathModule } from '@lobos/library';
import { PipesModule } from '../../../pipes/pipes.module';
import { ArticleSliderComponent } from './article-slider/article-slider.component';
import { BlogSliderComponent } from './blog-slider/blog-slider.component';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { ComponentNotConfiguredComponent } from './component-not-configured/component-not-configured.component';
import { CategoryGridComponent } from './category-grid/category-grid.component';
import { FaqComponent } from './faq/faq.component';
import { ImageGridComponent } from './image-grid/image-grid.component';
import { LogoSliderComponent } from './logo-slider/logo-slider.component';
import { CmsUiImageSliderComponent } from './image-slider/image-slider.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ProductSliderComponent } from './product-slider/product-slider.component';
import { TeaserCarouselComponent } from './teaser-carousel/teaser-carousel.component';
import { VideosComponent } from './videos/videos.component';
import { VimeoComponent } from './vimeo/vimeo.component';
import { YoutubeComponent } from './youtube/youtube.component';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { NgxMasonryModule } from 'ngx-masonry';
import { TranslocoModule } from '@ngneat/transloco';

const components: any[] = [
  ArticleSliderComponent,
  BlogSliderComponent,
  CategoryGridComponent,
  CollapsibleComponent,
  ComponentNotConfiguredComponent,
  ContentComponent,
  FaqComponent,
  ImageGridComponent,
  CmsUiImageSliderComponent,
  LogoSliderComponent,
  NewsletterComponent,
  PortfolioComponent,
  ProductSliderComponent,
  TeaserCarouselComponent,
  VideosComponent,
  VimeoComponent,
  YoutubeComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MarkdownModule.forRoot(),
    SwiperModule,
    ComponentsModule,
    LocalizeUrlPathModule,
    PipesModule,
    TranslocoModule,
    TranslocoLocaleModule,
    NgxMasonryModule,
  ],
  exports: components,
})
export class CmsComponentsModule {}
